module.exports = __webpack_public_path__ + "img/xiaoa.4934540f.png";